/** The labeling front door (port of labeling_index.py's inline page,
 *  same address /labeling/).
 *
 * Cards for the four grid tools plus Label Studio, with live remaining
 * counts. The Jinja page computed counts server-side at render; the
 * port reads them from /labeling/counts (same helper, JSON'd) so the
 * cards still say how much work is left.
 */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../../lib/api'
import './labeling.css'

type Counts = { ball: number | null; jersey: number | null; label_studio_url: string }

const CARDS = [
  ['/labeling/ball-grid/', 'Ball / not-ball grid',
   '100 crops at a time; click cycles ball, not ball, unsure', 'ball'],
  ['/labeling/jersey-legibility/', 'Jersey legibility',
   'legible / not legible triage for the v4 jersey crops', 'jersey'],
  ['/labeling/jersey-grid/', 'Jersey numbers',
   'confirm predicted-number bins, keypad-correct the wrong ones', 'jersey'],
  ['/labeling/sequence/', 'Ball sequences',
   'click the ball through contiguous frame runs, 4 panels at a time', null],
] as const

export default function LabelingIndex() {
  const [counts, setCounts] = useState<Counts | null>(null)

  useEffect(() => {
    api<Counts>('/labeling/counts')
      .then(setCounts)
      .catch(() => setCounts(null)) // cards render without counts
  }, [])

  const left = (key: 'ball' | 'jersey' | null) =>
    key && counts ? counts[key] : null

  return (
    <div className="lab-index">
      <h1>labeling</h1>
      {CARDS.map(([href, title, desc, key]) => (
        <Link key={href} className="card" to={href}>
          {left(key) != null && (
            <span className="n">{left(key)!.toLocaleString('en-US')} left</span>
          )}
          <span className="t">{title}</span>
          <div className="d">{desc}</div>
        </Link>
      ))}
      {counts?.label_studio_url && (
        <a className="card" href={counts.label_studio_url}
           target="_blank" rel="noopener noreferrer">
          <span className="t">Label Studio</span>
          <div className="d">full annotation UI for anything the grids do not cover</div>
        </a>
      )}
    </div>
  )
}
